export enum UserNoteSort {
	CREATION_DATE_TIME = 'CREATION_DATE_TIME',
	NOTE = 'NOTE',
}
